import { ApiProperty } from '../../codegen';
import { IsEnum, IsNumber, IsOptional, Min } from '../../validators';

export const APP_COLOR_VALUES = ['blue', 'green'] as const;
export type TAppColor = (typeof APP_COLOR_VALUES)[number];

export const OVERLAP_PHASE_VALUES = [
  'idle',
  'pre_switch_drain',
  'post_switch_smoke_hold',
  'overlap_drain',
] as const;
export type TOverlapPhase = (typeof OVERLAP_PHASE_VALUES)[number];

export class BillingOverlapPublicStatusDto {
  @ApiProperty()
  @IsEnum(OVERLAP_PHASE_VALUES, { groups: ['error'] })
  phase: TOverlapPhase;

  @ApiProperty({ required: false })
  @IsOptional({ groups: ['error'] })
  @IsEnum(APP_COLOR_VALUES, { groups: ['error'] })
  drainingColor?: TAppColor | null;

  @ApiProperty({ required: false })
  @IsOptional({ groups: ['error'] })
  @IsEnum(APP_COLOR_VALUES, { groups: ['error'] })
  admittingColor?: TAppColor | null;

  @ApiProperty({ required: false })
  @IsOptional({ groups: ['error'] })
  @IsNumber({}, { groups: ['error'] })
  @Min(0, { groups: ['error'] })
  updatedAtMs?: number;
}
